import { PrimaryButton } from "@mnk/frontend/components/ui/button/PrimaryButton";
import { trpc } from "@mnk/frontend/lib/trpc";
import { useState } from "react";

interface Props {
  onClose: () => void;
  officeId: string;
  parentId?: string;
  afterCreateItem: () => void;
}

export const NewFolderModal = ({ onClose, officeId, parentId, afterCreateItem }: Props) => {
  const [name, setName] = useState("");
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const itemMutation = trpc.createItem.useMutation();

  const onSubmit = async () => {
    setProcessing(true);
    try {
      await itemMutation.mutateAsync({
        itemType: "folder",
        name,
        officeId,
        parentId,
      });
    } catch (error) {
      setError("フォルダの作成に失敗しました");
    } finally {
      setProcessing(false);
      afterCreateItem();
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black/40 flex justify-center items-center z-50"
      onClick={onClose}
      onKeyDown={(e) => {
        if (e.key === "Escape") {
          onClose();
        }
      }}
    >
      <div className="w-full h-full flex justify-center items-center">
        <div
          className="bg-white rounded-lg shadow-lg w-96 flex flex-col"
          onClick={(e) => e.stopPropagation()}
          onKeyDown={(e) => {
            if (e.key === "Escape") {
              onClose();
            }
          }}
        >
          <div className="bg-blue-400 rounded-t-lg flex items-center p-2 h-10 flex-shrink-0">
            <h2 className="text-center text-md font-bold text-white flex-1">フォルダを作成</h2>
            <button type="button" className="text-white hover:text-blue-100 text-lg leading-none" onClick={onClose}>
              ✕
            </button>
          </div>
          <div className="p-4 flex flex-col gap-2 rounded-b-lg">
            <div className="flex flex-col gap-2">
              <label htmlFor="password" className="text-sm text-gray-500">
                フォルダ名
              </label>
              <input
                id="name"
                type="text"
                className="border border-gray-300 rounded-md p-2"
                placeholder="フォルダ名を入力"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>

            {error && <p className="text-sm text-red-500 text-center">{error}</p>}

            <PrimaryButton
              className="w-full"
              onClick={async (e) => {
                e.preventDefault();
                await onSubmit();
                onClose();
              }}
              disabled={processing}
            >
              作成
            </PrimaryButton>
          </div>
        </div>
      </div>
    </div>
  );
};
